import { Card, Col, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import WhatsApp from '../Integracoes/WhatsApp';
import './index.css';

export default function ConectarNumeros() {
  const history = useHistory();

  return (
    <div className="conectar-numeros-pagina px-4">
      <div className="row">
        <div className="col-12">
          <div className="tituloPagina">
            Conectar Números
            <Button variant="outline-secondary" size="sm" onClick={() => history.push('/configuracao/ramais')}>
              Ver Números Conectados
            </Button>
          </div>
        </div>
      </div>
      <div className="row">
        <Col md="6" className="mb-4">
          <Card className="p-4 cardIntegracao h-100">
            <Card.Header>WhatsApp</Card.Header>
            <WhatsApp />
          </Card>
        </Col>
      </div>
    </div>
  );
}
